import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartOffcanvasPreviewComponent } from './cart-offcanvas-preview.component';
import { CartPreviewModule } from '../preview/cart-preview.module';



@NgModule({
  declarations: [
    CartOffcanvasPreviewComponent,
  ],
  imports: [
    CommonModule,

    CartPreviewModule,
  ],
  exports: [
    CartOffcanvasPreviewComponent,
  ]
})
export class CartOffcanvasPreviewModule { }
